import { Node_Type } from "./../../ricos-schema/legacy/wix/rich_content/v1";
function getListSymbol(indentation, nodeTypeName) {
  const listSymbol = {
    [Node_Type.BULLETED_LIST]: ["disc", "circle", "square"],
    [Node_Type.ORDERED_LIST]: ["decimal", "lower-latin", "lower-roman"]
  }[nodeTypeName];
  return listSymbol[indentation % listSymbol.length];
}
export {
  getListSymbol
};
//# sourceMappingURL=getListSymbol.js.map
